
        import * as module0 from '../images/alarme.jpg';import * as module1 from '../images/board.jpg';import * as module2 from '../images/chauffage.jpg';import * as module3 from '../images/digicode.jpg';import * as module4 from '../images/ecrevis.jpg';import * as module5 from '../images/entete.jpg';import * as module6 from '../images/favicon.png';import * as module7 from '../images/francois.jpg';import * as module8 from '../images/logo.svg';import * as module9 from '../images/plaques-cuisson.jpg';import * as module10 from '../images/prise-garage.jpg';import * as module11 from '../images/prise-renforcee.jpg';import * as module12 from '../images/seynod.jpg';import * as module13 from '../images/tableau.jpg';import * as module14 from '../images/triphase.jpg';import * as module15 from '../images/ventilateur.jpg';import * as module16 from '../images/wifi.jpg'
        const modules = {
            "../images/alarme.jpg": module0,
            "../images/board.jpg": module1,
            "../images/chauffage.jpg": module2,
            "../images/digicode.jpg": module3,
            "../images/ecrevis.jpg": module4,
            "../images/entete.jpg": module5,
            "../images/favicon.png": module6,
            "../images/francois.jpg": module7,
            "../images/logo.svg": module8,
            "../images/plaques-cuisson.jpg": module9,
            "../images/prise-garage.jpg": module10,
            "../images/prise-renforcee.jpg": module11,
            "../images/seynod.jpg": module12,
            "../images/tableau.jpg": module13,
            "../images/triphase.jpg": module14,
            "../images/ventilateur.jpg": module15,
            "../images/wifi.jpg": module16,
        };
        export default modules;
      